import React, { useMemo } from 'react';
import { nanoid } from 'nanoid/non-secure';
export const GroupContext = React.createContext({});
export const RemoteGroup = ({ children }) => {
    const id = useMemo(() => nanoid(6), []);
    return (React.createElement(GroupContext.Provider, { value: { id } }, children));
};
